import { useState } from 'react';
import { fileUrl, uploadDirect } from '../api/client';
import { useToast } from '../context/ToastContext';

/**
 * One optional video for a listing - product, service, vehicle, property,
 * animal or the shop itself. Uploaded straight to storage with a signed URL
 * (no size limit); the form only holds the URL. Customers see it on the
 * detail page.
 */
const VideoUploader = ({ label = 'Video (optional)', hint, value, onChange, folder = 'misc' }) => {
  const toast = useToast();
  const [progress, setProgress] = useState(null);
  const uploading = progress !== null;

  const choose = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setProgress(0);
    try {
      onChange(await uploadDirect(file, folder, setProgress));
    } catch (err) {
      toast.error(err.message || 'Could not upload that video');
    } finally { setProgress(null); e.target.value = ''; }
  };

  const picker = (text) => (
    <label className="btn ghost" style={{ cursor: uploading ? 'progress' : 'pointer' }}>
      {text}
      <input type="file" accept="video/*" hidden disabled={uploading} onChange={choose} />
    </label>
  );

  return (
    <div style={{ marginBottom: 14, display: 'grid', gap: 8 }}>
      <div className="t-small" style={{ fontWeight: 700 }}>{label}</div>
      {value && !uploading ? (
        <>
          <video src={fileUrl(value)} controls style={{ width: '100%', maxHeight: 320, borderRadius: 12, background: '#000' }} />
          <div className="row" style={{ gap: 12 }}>
            {picker('Replace video')}
            <button type="button" className="link-btn" style={{ color: 'var(--danger)' }} onClick={() => onChange('')}>Remove</button>
          </div>
        </>
      ) : picker(uploading ? `Uploading ${Math.round(progress * 100)}%` : '🎬 Add a video')}
      {hint ? <div className="t-tiny">{hint}</div> : null}
    </div>
  );
};

export default VideoUploader;
